import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { RECORD_CHILD_INVITE, RECORD_FUB_OUTBOUND_INQUIRY, SYNC_CUSTOMER_TO_FUB } from './graphql/mutations';
import { RecordChildInviteMutation, RecordFubOutboundInquiryMutation, RecordOutboundInquiryInput, SyncCustomerToFubMutation } from 'app/graphql/graphql';

@Injectable({ providedIn: 'root' })
export class FubAnalyticsApiService {
    constructor(
        private readonly apollo: Apollo
    ) { }

    public record(input: RecordOutboundInquiryInput): Observable<boolean> {
        return this.apollo.mutate<RecordFubOutboundInquiryMutation>({
            mutation: RECORD_FUB_OUTBOUND_INQUIRY,
            variables: { input }
        }).pipe(
            map(response => response.data.followUpBoss.recordOutboundInquiry)
        );
    }

    public recordChildInvite(recipientEmail: string, message: string | null): Observable<boolean> {
        return this.apollo.mutate<RecordChildInviteMutation>({
            mutation: RECORD_CHILD_INVITE,
            variables: { recipientEmail, message }
        }).pipe(
            map(response => response.data.followUpBoss.recordChildInvite)
        );
    }

    public syncCustomerToFub(): Observable<boolean> {
        return this.apollo.mutate<SyncCustomerToFubMutation>({
            mutation: SYNC_CUSTOMER_TO_FUB
        }).pipe(
            map(response => response.data.followUpBoss.syncCustomerToFub)
        );
    }
}
